<template>
  <div>
    <div class="text-center">
      <v-img style="margin: auto;" width="140px" src="../assets/Fe-Symbol.jpg"></v-img>
    </div>
    <v-container>
      <ValidationObserver v-slot="{invalid}">
        <div>
          <ValidationProvider rules="required" name="Username" v-slot="{ errors }">
            <v-text-field
              color="#8e5b43"
              :error-messages="errors"
              v-model="input.username"
              label="Username"
              append-icon="mdi-account-circle-outline"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="Password" rules="required" v-slot="{ errors }">
            <v-text-field
              color="#8e5b43"
              type="password"
              :error-messages="errors"
              v-model="input.password"
              label="Password"
              append-icon="mdi-lock-outline"
            ></v-text-field>
          </ValidationProvider>
        </div>
        <div class="text-center">
          <v-btn
            @click="login"
            :disabled="invalid"
            large
            :loading="loading"
            color="#72412c"
            class="mt-2"
            style="color:white"
          >LOGIN</v-btn>
        </div>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import queryString from "query-string";

export default {
  data() {
    return {
      serverUrl: `https://api-sme-prod.zwiz.app/`,
      input: {
        username: "",
        password: ""
      },
      query: "",
      pageid: "",
      loading: false
    };
  },
  mounted() {
    this.queryinit();
  },
  methods: {
    queryinit() {
      var vm = this;
      vm.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;

      if (vm.query.pageid) vm.pageid = vm.query.pageid;
    },
    login() {
      var vm = this;
      var userid;
      vm.loading = true
      if (this.query.apptype == "line") {
        userid = this.$store.state.profile.userId + "__" + this.pageid;
      } else {
        userid = this.query.userid;
      }
      var data = { id: this.input.username, password: this.input.password };
      axios
        .post(this.serverUrl + "cmclogin", data, {
          headers: { Authorization: "Basic userid sessiontoken" },
          params: { userid: userid, pageid: this.pageid }
        })
        .then(async response => {
          if (response.data.responsecode == 200) {
            vm.loading = false
            if (response.data.data.length) {
              await vm.$swal.fire({
                icon: "success",
                title: "Login Success!"
              });
              if (vm.query.apptype == "line") {
                await vm.$liff.sendMessages([
                  { type: "text", text: "Login success" }
                ]);
                vm.$liff.closeWindow();
              } else {
                MessengerExtensions.requestCloseBrowser(
                  function success() {},
                  function error() {
                    window.close();
                  }
                );
              }
            } else {
              vm.$swal.fire({
                icon: "error",
                text: "Username หรือ Password ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"
              });
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" >
* {
  font-family: "Roboto", sans-serif !important;
}
</style>